/* tslint:disable */
/* eslint-disable */
/**
 * Strømbestilling API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Hvilke steg ordren går gjennom før sikringen sendes til UtilityCloud
 * @export
 */
export const SikringFlyt = {
    SigneringKontraktSikring: 'SIGNERING_KONTRAKT_SIKRING',
    KontraktSikring: 'KONTRAKT_SIKRING',
    KunSikring: 'KUN_SIKRING'
} as const;
export type SikringFlyt = typeof SikringFlyt[keyof typeof SikringFlyt];


export function instanceOfSikringFlyt(value: any): boolean {
    for (const key in SikringFlyt) {
        if (Object.prototype.hasOwnProperty.call(SikringFlyt, key)) {
            if (SikringFlyt[key as keyof typeof SikringFlyt] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SikringFlytFromJSON(json: any): SikringFlyt {
    return SikringFlytFromJSONTyped(json, false);
}

export function SikringFlytFromJSONTyped(json: any, ignoreDiscriminator: boolean): SikringFlyt {
    return json as SikringFlyt;
}

export function SikringFlytToJSON(value?: SikringFlyt | null): any {
    return value as any;
}

export function SikringFlytToJSONTyped(value: any, ignoreDiscriminator: boolean): SikringFlyt {
    return value as SikringFlyt;
}

